<template>
    <div class="o-paymentStatus">
        <m-title title="Status płatności" />

        <div class="o-paymentStatus__loader" v-if="paymentAwaiting">
            <span class="a-select__listLoader">
                <a-icon icon="SpinnerSmall" />
            </span>
            <p>Oczekiwanie na potwierdzenie płatności...</p>
        </div>

        <div class="o-paymentStatus__success" v-else-if="paymentSuccess">
            <p>
                Płatność przebiegła pomyślnie.
            </p>
            <div class="l-row">
                <div class="l-row__column">
                    <a-button
                        @click="$router.push({ name: 'dashboard' })"
                        submit
                        type="fullwidth"
                    >
                        Przejdź do strony głównej
                    </a-button>
                </div>
            </div>
        </div>

        <div class="o-paymentStatus__error" v-else-if="paymentError">
            <p>Płatność zakończona niepowodzeniem.</p>

            <div class="l-row" v-if="paymentToRepeat">
                <div class="l-row__column">
                    <a-button @click="onPaymentRepeat" type="fullwidth">
                        Powtórz płatność
                    </a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import localforage from 'localforage'
const namespace = `${process.env.PACKAGE_NAME || 'app'}`

export default {
    name: 'PaymentStatus',
    async beforeMount() {
        const paymentId = await localforage.getItem(
            `${namespace}.subscriptionPaymentId`
        )
        if (paymentId) {
            this.$store.dispatch('subscriptions/getPaymentStatus', paymentId)

            this.paymentStatusInterval = setInterval(() => {
                if (this.paymentAwaiting) {
                    this.$store.dispatch(
                        'subscriptions/getPaymentStatus',
                        paymentId
                    )
                } else if (this.paymentSuccess) {
                    clearInterval(this.paymentStatusInterval)
                    localforage.removeItem(`${namespace}.subscriptionPaymentId`)
                } else if (this.paymentError) {
                    clearInterval(this.paymentStatusInterval)
                }
            }, 5000)
        } else {
            this.$router.push({ name: 'dashboard' })
        }
    },
    beforeDestroy() {
        clearInterval(this.paymentStatusInterval)
    },
    computed: {
        paymentSuccess() {
            return this.paymentStatus === 'success'
        },
        paymentError() {
            return this.paymentStatus === 'error'
        },
        paymentAwaiting() {
            return !(this.paymentSuccess | this.paymentError)
        },
        paymentStatus() {
            return this.$store.getters['subscriptions/paymentStatus']
        },
        userPeriodPrices() {
            return this.$store.getters['payments/getUserPeriodPrices']
        },
        paymentToRepeat() {
            return this.userPeriodPrices.find(
                payment => payment.repeat === false
            )
        }
    },
    watch: {
        paymentError(isPaymentError) {
            if (isPaymentError) {
                this.$store.dispatch('payments/fetchUserPeriodPrices')
            }
        }
    },
    data() {
        return {
            paymentStatusInterval: null
        }
    },
    methods: {
        async onPaymentRepeat() {
            try {
                const response = await this.$store.dispatch(
                    'payments/repeatPayment',
                    this.paymentToRepeat.user_period_price_id
                )
                const { url, paymentId } = response.data.data

                localforage.setItem(
                    `${namespace}.subscriptionPaymentId`,
                    paymentId
                )

                window.location.href = url
            } catch (err) {
                let errorMessage = 'Spróbuj ponownie póżniej.'
                try {
                    errorMessage = err.response.data.data.errors
                } finally {
                    this.$store.dispatch('addNotification', {
                        type: 'danger',
                        content: `Wystąpił błąd. ${errorMessage}`
                    })
                }
            }
        }
    }
}
</script>
